import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValoresFormulario } from '../utils/interfaces/summary.interface';
import { RequestUtilsService } from '../utils/request-admin-utils.service';


@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent {
  @Input() summaryData_archivos!: ValoresFormulario[];
  @Input() statusRequest!: string;
  @Input() correction!: boolean;
  @Input() formulario?: string;
  @Output() selectedFiles = new EventEmitter<{ event: any, title: string, section: string, key: number }>()

  constructor(
    private request_utils: RequestUtilsService,
  ) { }

  selectionData(event: any, title: string, section: string, key: number) {
    this.selectedFiles.emit({ event, title, section, key })
  }

  async downloadFile(file: string) {
    const url = await this.request_utils.download_file(file)
    this.download(url.download_url);
  }

  /**
   * Retorna los archivos que comienzan con "ADM".
   */
  get adminFiles(): ValoresFormulario[] {
    return (this.summaryData_archivos || []).filter(f => {
      const valor = f && (f as any).valor ? String((f as any).valor).trim().toUpperCase() : '';
      return valor.startsWith('ADM');
    });
  }

  /**
   * Retorna los archivos que NO comienzan con "ADM".
   */
  get otherFiles(): ValoresFormulario[] {
    return (this.summaryData_archivos || []).filter(f => {
      const valor = f && (f as any).valor ? String((f as any).valor).trim().toUpperCase() : '';
      return !valor.startsWith('ADM');
    });
  }

  /**
   * Título dinámico para la sección de archivos ADM según el formulario.
   */
  get adminSectionTitle(): string {
    const form = (this.formulario || '').toString();
    switch (form) {
      case 'FRM_CARTA_RESGUARDO':
        return 'Descarga tu Carta de Resguardo:';
      case 'FRM_DEPARTAMENTO_MERCED':
        return 'Descarga tu Detalle de Reserva:';
      case 'FRM_OC_OPTICA':
        return 'Descarga tu Orden de Compra:';
      case 'FRM_CABANA_EL_QUISCO':
        return 'Descarga tu Comprobante de Reserva:';
      default:
        return 'Descarga el documento asociado a tu solicitud:';
    }
  }

  truncateText(text: string): string {
    if (text.length > 50) {
      return text.substring(0, 50) + '...';
    }
    return text;
  }

  download(url: any) {
    const a = document.createElement('a')
    a.setAttribute('target', '_blank');
    a.href = url
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
